export function getPageTitle(entityName: string | undefined | null): string {
  return `${ entityName } :: Pravo`;
}
